import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderItemType from 'owa-service/lib/contract/AttachmentDataProviderItemType';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import handleGetItemsResponse from './handleGetItemsResponse';
import moveFoldersToTheBeginning from './moveFoldersToTheBeginning';
import sortFileProviderItems from './sortFileProviderItems';
import { BoxItem, getBoxItems, isBoxFolderItem, PathCollection } from 'owa-fileprovider-services';
import {
    createAttachmentDataProviderItemsResponse,
    createFailedAttachmentDataProviderItemsResponse,
} from './createAttachmentDataProviderItemsResponse';
import {
    FileAttachmentDataProviderItemType,
    FolderAttachmentDataProviderItemType,
} from '../constants';

function getLocation(pathCollection: PathCollection): string {
    const entries = pathCollection.entries || [];
    return `/${entries.map(entry => entry.name).join('/')}`;
}

function createAttachmentDataProviderItem(item: BoxItem): AttachmentDataProviderItem {
    return {
        __type: isBoxFolderItem(item)
            ? FolderAttachmentDataProviderItemType
            : FileAttachmentDataProviderItemType,
        Id: item.id,
        AttachmentProviderId: null,
        Location: `${getLocation(item.path_collection)}/${item.name}`,
        Modified: item.modified_at,
        ModifiedBy: item.modified_by ? item.modified_by.name : null,
        Name: item.name,
        ProviderType: AttachmentDataProviderType.Box,
        Size: item.size,
        Type: isBoxFolderItem(item)
            ? AttachmentDataProviderItemType.Folder
            : AttachmentDataProviderItemType.File,
    };
}

const createResponseFunc = (items: BoxItem[]) =>
    createAttachmentDataProviderItemsResponse(items, createAttachmentDataProviderItem);

export default async function getBoxFileProviderItems(
    folderId: string,
    sortColumn: AttachmentItemsSortColumn,
    sortOrder: AttachmentItemsSortOrder
): Promise<GetAttachmentDataProviderItemsResponse> {
    const { errorResponse, result } = await getBoxItems(folderId);

    if (result) {
        const response = handleGetItemsResponse(
            result,
            null /* errorResponse */,
            createResponseFunc,
            createFailedAttachmentDataProviderItemsResponse
        );

        sortFileProviderItems(response.Items, sortColumn, sortOrder);
        response.Items = moveFoldersToTheBeginning(response.Items);

        return response;
    } else {
        return handleGetItemsResponse(
            null /* result */,
            errorResponse,
            createResponseFunc,
            createFailedAttachmentDataProviderItemsResponse
        );
    }
}
